import { apiClient } from './apiClient';

const jsonHeaders = (csrfToken: string | null) => ({
    'Content-Type': 'application/json',
    'X-XSRF-TOKEN': csrfToken ?? '',
});

/**
 * Email + password sign-in. Sets the same session cookie the SSO callback does,
 * so everything downstream is unchanged.
 *
 * Only accounts created by accepting an invite have a password; SSO accounts
 * fail here with the same generic error as a wrong password.
 */
const loginWithPassword = async (
    csrfToken: string | null,
    payload: { email: string; password: string },
): Promise<void> => {
    if (csrfToken === null) return;
    await apiClient.post('api/auth/login', JSON.stringify(payload), {
        headers: jsonHeaders(csrfToken),
    });
};

/**
 * Always resolves for a well-formed email, whether or not an account exists —
 * the API deliberately gives the same answer either way.
 */
const requestPasswordReset = async (
    csrfToken: string | null,
    email: string,
): Promise<void> => {
    if (csrfToken === null) return;
    await apiClient.post('api/auth/forgot-password', JSON.stringify({ email }), {
        headers: jsonHeaders(csrfToken),
    });
};

const resetPassword = async (
    csrfToken: string | null,
    payload: {
        token: string;
        email: string;
        password: string;
        password_confirmation: string;
    },
): Promise<void> => {
    if (csrfToken === null) return;
    await apiClient.post('api/auth/reset-password', JSON.stringify(payload), {
        headers: jsonHeaders(csrfToken),
    });
};

export { loginWithPassword, requestPasswordReset, resetPassword };
